import { render } from "./ShowcaseSubs.vue?vue&type=template&id=bda3f408&scoped=true"
import script from "./ShowcaseSubs.vue?vue&type=script&lang=js"
export * from "./ShowcaseSubs.vue?vue&type=script&lang=js"

import "./ShowcaseSubs.vue?vue&type=style&index=0&id=bda3f408&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda3f408"]])

export default __exports__